"use client"
import {cn} from "@/lib/utils";
import {Button} from "@/components/ui/button";
import { AppLink } from "@/components/common/app-link";

// import bg from "/images/Pave-scaled.jpg";

interface PaveScaleCardProps {
    title: string | React.ReactNode;
    buttonLabel: string;
    link?: string;
    className?: string;
    titleClassName?: string;
    image?: string;
}

export function PaveScaleCard(props: PaveScaleCardProps) {
    const content = (
        <div style={{backgroundImage: props.image ? `url('${props.image}')` :  `url('/images/Pave-scaled.jpg')`}}
             className={cn("group bg-cover bg-center flex flex-col justify-end relative cursor-pointer", props.className)}>

            <div className={"absolute left-0 top-0 w-full h-full bg-black/[20%]"}/>

            <div className={cn("rounded-xl p-8 bg-bottom relative")}>
                <h3 className={cn("text-2xl font-exo-bold text-white", props.titleClassName)}>{props.title}</h3>

                <Button variant={"yellowHover"} size={"site"}
                    className={"group-hover:bg-yellow-400 group-hover:text-black"}>{props.buttonLabel}</Button>
            </div>
        </div>
    );

    if (props.link) {
        return <AppLink to={props.link}>{content}</AppLink>;
    }

    return content;
}

interface OnlyImageBgCardProps {
    className?: string;
    imageSrc: string;
}


export function OnlyImageBgCard(props: OnlyImageBgCardProps) {
    return (<div className={cn("w-full bg-cover bg-center", props.className)}
                 style={{backgroundImage: `url('${props.imageSrc}')`}}/>
    );
}
